import { createStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';


export const styles = (theme:Theme) => createStyles({
    root:{
        flexShrink: 0,
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing.unit * 2.5,
        marginRight: theme.spacing.unit,
      },
    iconButton: {
        padding: theme.spacing.unit/4
    },
    progress: {
      margin: theme.spacing.unit * 2,
    },
    leftDisplay:{
      marginLeft: theme.spacing.unit * 4,
    },
    textBar:{
        marginLeft:'-10px'
    },
    posRel:{
      position:"relative"
    },
    textBarNega:{
      color: "#000",
      position: "absolute",
      fontSize: "30px",
      alignItems: "center",
      fontFamily:"Roboto",
      left: "0",
      width: "120px",
      top: "3px",
      textAlign: "center",
      display: "inline-block"

    },
    textBarNega2:{
      color: "#666",
      position: "absolute",
      fontSize: "40px",
      alignItems: "center",
      left: "0",
      top: "40px",
      display: "inline-block",
      textAlign: "center",
      width: "120px",
      fontFamily: "Roboto"
    },
    textBarNega3:{
      color: "#666",
      position: "absolute",
      fontSize: "14px",
      alignItems: "center",
      left: "0",
      bottom: "19px",
      display: "inline-block",
      textAlign: "center",
      width: "120px",
      fontFamily: "Roboto"
    },
    textSize:{
      fontSize:'14px'
    },
    textBold:{
      fontWeight: 'bold'
    },
    textEllipsis: {
          width: '100%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          paddingRight: theme.spacing.unit
    },
    subTitle: {
    },
    linearProgressBox:{
      height:'35px',
      width:'370px',
      border:'1px solid #DDDDDD',
      borderRadius:'30px',
      marginTop:'40px',
      paddingLeft:'6px',
      paddingRight:'6px',
      fontSize:'10px',
    },
     noneBox:{
      height:'35px',
      width:'370px',
      marginTop:'40px',
      paddingLeft:'6px',
      paddingRight:'6px',
      fontSize:'10px',
    },
    linearProgressBar:{
      marginTop:'-12px',
      width:'148px',
      marginLeft:'0px'
    },
    previewButton: {
          background: theme.palette.common.white,
          border: '1px solid #DDDDDD',
          boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.0519701)',
          padding: '-1px',
          opacity: 0.7,
          '& svg': {
              marginRight: theme.spacing.unit
          }
    },
    viewDetails: {
          opacity: 0.7,
          fontSize: '14px',
          paddingLeft: '26px',
          paddingTop: '10px',
          color: theme.palette.text.secondary
    },
    previewBtn:{
      float:'right'
    },
    textValue:{
      margin:'5px 5px 0px',
    },
    icon: {
      margin:'-4px 147px 0px',
      fontSize: '18px'
    },
  });  